export const fetchWithToken = async (url, options = {}) => {
  try {
    let accessToken = localStorage.getItem("access_token");
    let refreshToken = localStorage.getItem("refresh_token");
    if (!accessToken || !refreshToken) {
      window.location.href = "/laeeblyforshorts";
      throw new Error("No access or refresh token");
    }

    let response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.status === 401) {
      // 토큰 만료 시 갱신 시도
      const { refreshAccessToken } = await import(
        "../pages/MusicCollaboration/Home"
      );
      try {
        const newAccessToken = await refreshAccessToken();
        if (!newAccessToken) throw new Error("토큰 갱신 실패");

        // 새로운 토큰으로 재시도
        response = await fetch(url, {
          ...options,
          headers: {
            ...options.headers,
            Authorization: `Bearer ${newAccessToken}`,
          },
        });
      } catch (err) {
        // refresh token도 만료/실패 시
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        window.location.href = "/laeeblyforshorts";
        throw err;
      }
    }

    if (!response.ok) {
      const errorText = await response.text();
      console.error("API 실패 응답:", errorText);
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};
